<template>
  <div class="flex w-full justify-center items-center">

    <Step
      :question="{
        label: 'Select a muscle group to get started'
      }"
    >
      <div class="p-2 grid grid-cols-2 lg:grid-cols-3 bg-dark-gray">
        <div v-for="image in images" :key="image.src"
          :class="{  's-grow': !image.disabled }"
          class="m-2"
        >
          <div 
            @click="setup(image.value, image.disabled)" 
            class="h-full w-full relative flex flex-col items-center justify-center border-lg bg-blue-200 rounded-lg cursor-pointer p-4"
          >
            <div v-if="image.disabled" class="overlay rounded-lg" />
            <img
              class="s-image"
              :src="image.src"
              :alt="image.label"
            />
            <p class="text-black text-2xl font-bold mt-2">
              {{ image.label }}
            </p>
          </div>
        </div>
      </div>

      <t-modal v-model="show_disclaimer" :hideCloseButton="true" :clickToClose="false" :escToClose="false">
        <div class="mt-1">
          <p class="text-sm">
            This tool does not provide medical advice.
            It is intended for informational purposes only.
            It is not a substitute for professional medical advice, diagnosis or treatment.
            Never ignore professional medical advice in seeking treatment because of something you have read on this site. 
            If you think you may have a medical emergency, immediately call your doctor or dial 911.
          </p>
        </div>
        <div class="w-full flex justify-center mt-4 mb-2">
          <t-button @click="show_disclaimer = false" variant="forward">
            <strong>I Understand</strong>
          </t-button>
        </div>
      </t-modal>

      

    </Step>

  </div>
</template>

<script>
import Step from '../components/Step';
import { mapActions } from 'vuex';


export default {
  name: 'ExamSelector',
  components: {
    Step,
  },
  computed: {
    show_disclaimer: {
      get() {
        return this.$store.state.show_disclaimer;
      },
      set(val) {
        this.$store.commit('SET_SHOW_DISCLAIMER', val);
      }
    }
  },
  data() {
    return {
      images: [
        { src: '../images/Hip.png', label: 'Hip', value: 'hip' },
        { src: '../images/Knee.png', label: 'Knee', value: 'knee' },
        { src: '../images/Shoulder.png', label: 'Shoulder', value: 'shoulder' },
        { src: '../images/Wrist-Hand.png', label: 'Hand & Wrist', value: 'hand_elbow', disabled: false },
        { src: '../images/Foot-Ankle.png', label: 'Foot & Ankle', value: 'foot_ankle', disabled: false },
        { src: '../images/Spine.png', label: 'Spine', value: 'spine', disabled: false },
      ]
    }
  },
  methods: {
    ...mapActions([
      'setup_exam',
    ]),
    setup(exam, disabled) {
      if (disabled) return;
      else this.setup_exam(exam);
    }
  }
}
</script>


<style lang="scss" scoped>
.s-grow { 
  transition: all .4s ease;
  &:hover { transform: scale(1.05); }
}

.s-image {
  width: 8em;
  max-width: 120px;
  max-height: 120px;
}

.overlay {
  position: absolute;
  // position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.35);
  z-index: 20;
  cursor: default!important;
}

</style>